export function trackArticleSections(): void {
  const root = document.getElementById('article-root');
  const contents = document.getElementById('article-table-of-contents');
  if (!root || !contents) return;

  const select = root.querySelector<HTMLSelectElement>('#sap-evaluation-jump');
  const sections = Array.from(contents.querySelectorAll<HTMLAnchorElement>('a'))
    .map((link) => ({
      link,
      target: document.getElementById(link.hash.slice(1)),
    }))
    .filter(
      (section): section is { link: HTMLAnchorElement; target: HTMLElement } =>
        section.target !== null,
    );
  let activeLink: HTMLAnchorElement | undefined;
  let updatePending = false;

  const update = () => {
    updatePending = false;
    const desktopVisible = contents.getClientRects().length > 0;
    const mobileVisible = select && select.getClientRects().length > 0;
    if (!desktopVisible && !mobileVisible) return;

    const top = select
      ? parseFloat(
          getComputedStyle(sections[0]?.target || root).scrollMarginTop,
        )
      : parseFloat(getComputedStyle(contents).top);
    let currentLink: HTMLAnchorElement | undefined;
    for (const { target, link } of sections) {
      if (target.getBoundingClientRect().top > top + 1) break;
      currentLink = link;
    }
    if (select && document.activeElement !== select) {
      select.value = currentLink?.hash || '';
    }
    if (activeLink === currentLink) return;
    activeLink?.removeAttribute('aria-current');
    currentLink?.setAttribute('aria-current', 'location');
    activeLink = currentLink;
  };
  const scheduleUpdate = () => {
    if (updatePending) return;
    updatePending = true;
    requestAnimationFrame(update);
  };

  select?.addEventListener('blur', scheduleUpdate);
  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate);
  new ResizeObserver(scheduleUpdate).observe(root);
  scheduleUpdate();
}
